"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get GetSurveyParticipantResponseParams () {
        return GetSurveyParticipantResponseParams;
    },
    get GetSurveyParticipantResponseResponse () {
        return GetSurveyParticipantResponseResponse;
    },
    get SurveyAnswerOptionModel () {
        return SurveyAnswerOptionModel;
    },
    get SurveyQuestionAnswerModel () {
        return SurveyQuestionAnswerModel;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const GetSurveyParticipantResponseParams = _zod.z.object({
    surveyId: _utilsisomorphic.transformObjectId,
    employeeId: _utilsisomorphic.transformObjectId
});
const SurveyAnswerOptionModel = _zod.z.object({
    _id: _utilsisomorphic.transformObjectId,
    text: _zod.z.string(),
    description: _zod.z.string().optional(),
    order: _zod.z.number(),
    value: _zod.z.union([
        _zod.z.string(),
        _zod.z.number()
    ]).nullable().optional(),
    deleted: _zod.z.boolean().optional()
});
const SurveyQuestionAnswerModel = _zod.z.object({
    questionId: _utilsisomorphic.transformObjectId,
    questionText: _zod.z.string(),
    questionSubtitle: _zod.z.string().optional(),
    questionType: _zod.z.enum(Object.values(_models.SURVEY_QUESTION_TYPES)),
    order: _zod.z.number(),
    isRequired: _zod.z.boolean().optional(),
    options: _zod.z.array(SurveyAnswerOptionModel).optional(),
    value: _zod.z.union([
        _zod.z.string(),
        _zod.z.array(_zod.z.string())
    ]).nullable(),
    deleted: _zod.z.boolean().optional()
});
const GetSurveyParticipantResponseResponse = _zod.z.object({
    _id: _utilsisomorphic.transformObjectId,
    surveyId: _utilsisomorphic.transformObjectId,
    surveyName: _zod.z.string(),
    employeeId: _utilsisomorphic.transformObjectId,
    employeeName: _zod.z.string(),
    employeeEmail: _zod.z.string(),
    submittedAt: _utilsisomorphic.transformDate,
    answers: _zod.z.array(SurveyQuestionAnswerModel)
});
